<mat-tab-group mat-stretch-tabs ngClass.xs="xs">
    <mat-tab>
        <ng-template mat-tab-label i18n> Library </ng-template>
        <ng-template matTabContent>
            <app-resource-library
                [selection]="selection"
                [type_scope_id]="AppScope.COURSE"
                (select)="add.emit($event)"
            ></app-resource-library>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label i18n> My courses </ng-template>
        <ng-template matTabContent>
            <app-resource-library
                [selection]="selection"
                [type_scope_id]="AppScope.COURSE"
                context="author"
                (select)="add.emit($event)"
            ></app-resource-library>
        </ng-template>
    </mat-tab>
</mat-tab-group>
